@if (isLoading) {
  <app-chart-loading></app-chart-loading>
} @else {
  <div [id]="config.chartId" class="xy-canvas"></div>
}
